import * as React from 'react';
import { CSSTransition } from 'react-transition-group';

const BASE: string = 'animation';

export enum AnimationType {
  NONE = 'none',
  FADE = 'fade',
  SLIDEDOWN = 'slidedown',
  SLIDELEFT = 'slideleft',
  SLIDERIGHT = 'slideright',
  SLIDEUP = 'slideup'
}

interface AnimationComponentProps {
  addChildAnimation: AnimationType;
  removeChildAnimation: AnimationType;
  mountAnimation: AnimationType;
}

interface AnimationClasses {
  appear?: string;
  appearActive?: string;
  enter?: string;
  enterActive?: string;
  exit?: string;
  exitActive?: string;
}

interface AnimationProps {
  appear: boolean;
  classNames: AnimationClasses;
  enter: boolean;
  exit: boolean;
  in: boolean;
  timeout?: number;
}

export class Animation extends React.Component<AnimationComponentProps> {
  public static TIME: number = 200; // this ms time needs to match the s time in animation.scss

  public static defaultProps = {
    addChildAnimation: AnimationType.NONE,
    removeChildAnimation: AnimationType.NONE,
    mountAnimation: AnimationType.NONE
  };

  private generateAnimation(mountAnimation: AnimationType, addChildAnimation: AnimationType, removeChildAnimation: AnimationType) {
    const animationProps: AnimationProps = {
      classNames: {},
      appear: false,
      enter: false,
      exit: false,
      in: true
    };

    if (mountAnimation === AnimationType.NONE && addChildAnimation === AnimationType.NONE && removeChildAnimation === AnimationType.NONE) {
      return animationProps;
    }

    if (mountAnimation !== AnimationType.NONE) {
      animationProps.appear = true;
      animationProps.timeout = Animation.TIME;
      animationProps.classNames.appear = `${BASE}-${mountAnimation}-appear`;
      animationProps.classNames.appearActive = `${BASE}-${mountAnimation}-appear-active`;
    }

    if (addChildAnimation !== AnimationType.NONE) {
      animationProps.enter = true;
      animationProps.timeout = Animation.TIME;
      animationProps.classNames.enter = `${BASE}-${addChildAnimation}-enter`;
      animationProps.classNames.enterActive = `${BASE}-${addChildAnimation}-enter-active`;
    }

    if (removeChildAnimation !== AnimationType.NONE) {
      animationProps.exit = true;
      animationProps.timeout = Animation.TIME;
      animationProps.classNames.exit = `${BASE}-${removeChildAnimation}-leave`;
      animationProps.classNames.exitActive = `${BASE}-${removeChildAnimation}-leave-active`;
    }

    return animationProps;
  }

  public render() {
    const { addChildAnimation, mountAnimation, removeChildAnimation } = this.props;
    const animationProps: AnimationProps = this.generateAnimation(mountAnimation, addChildAnimation, removeChildAnimation);

    return <CSSTransition {...animationProps}>{this.props.children}</CSSTransition>;
  }
}
